// Bootstrap & utilitaires
import jquery from 'jquery';
window.$ = window.jQuery = jquery;

import './bootstrap';

import slickSrc from 'slick-carousel/slick/slick.min.js?raw';
new Function('module', 'exports', 'require', 'window', 'jQuery', slickSrc)(
    {}, {}, () => jQuery, window, jQuery
);
import 'slick-carousel/slick/slick.css';
import '../scss/_partials/slick-theme.scss';

function formatNumber(num, roundUp = false, showDecimals = true) {
    const format = (value, suffix) => {
        if (roundUp) {
            // arrondi classique
            value = Math.round(value);
        } else {
            // conserve 2 décimales
            value = value.toFixed(2);
            // // supprime .00
            value = value.replace(/\.00$/, '');
        }

        if (!showDecimals && !roundUp) {
            // si on ne veut pas afficher les décimales mais pas d'arrondi
            value = parseFloat(value).toFixed(1);
            value = value.replace(/\.0$/, '');
        }

        return value + suffix;
    };

    if (num >= 1e9) return format(num / 1e9, 'B');
    if (num >= 1e6) return format(num / 1e6, 'M');
    if (num >= 1e3) return format(num / 1e3, 'K');
    return num.toString();
}

function formatNumberCount(value, format, roundUp, showDecimal) {
    if (format === 'number' || format === 'currency') {
        let formatted;

        // console.log(value, roundUp, showDecimal)
        formatted = formatNumber(value, roundUp, showDecimal);

        if (format === 'currency') {
            formatted = formatted + '€';
        }

        return formatted;
    } else if (format === 'percent') {
        return value + '%';
    }
    return value;
}

function setEqualHeight(slider) {
    let maxHeight = 0;

    // Find the tallest slide
    $(slider).find('.slick-slide').each(function() {
        const h = $(this).outerHeight();
        if (h > maxHeight) maxHeight = h;
    });

    // Apply the same height to all slides
    $(slider).find('.slick-slide').css('height', maxHeight + 'px');
}


function openShare(platform) {
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title);
    let shareUrl = '';

    switch (platform) {
        case 'facebook':
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            break;
        case 'linkedin':
            shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
            break;
        case 'twitter':
            shareUrl = `https://x.com/intent/tweet?url=${url}&title=${title}`;
            break;
        case 'whatsapp':
            shareUrl = `https://web.whatsapp.com/send?text=${encodeURIComponent(`${title} ${url}`)}`;
            break;
        case 'email':
            shareUrl = `mailto:?subject=${title}&body=${encodeURIComponent(`${title} ${url}`)}`;
            break;
        case 'link':
            copyLink();
            break;
    }

    if (shareUrl) {
        window.open(shareUrl, '_blank', 'width=600,height=500');
    }
}

function copyLink() {
    navigator.clipboard.writeText(window.location.href).then(() => {
        alert("Link copied to clipboard!");
    });
}

var officeExt = ['doc', 'docx', 'xls', 'xlsx'];
var iFrameExt = ['pdf'];
var imagesExt = ['jpeg', 'webp', 'jpg', 'png', 'gif'];
var moviesExt = ['mp4', '3gp', 'webm', 'ogv', 'wav', 'mpeg', 'ogg', 'mp3', 'm3u'];

$(document).ready(function() {

    $('.share-btn').on('click', function (e) {
        e.preventDefault();
        const platform = $(this).data('sm');
        openShare(platform);
    });

    $('.share-link').on('click', function (e) {
        const target = document.getElementById('share-div');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (history && history.replaceState) {
            history.replaceState(null, '', '#share-div');
        } else {
            window.location.hash = 'share-div';
        }
    });

    // countup js
    $('.count').each(function () {
        var $this = $(this);
        var countTo = parseInt($this.attr('data-target'), 10);
        var countFormat = $this.attr('data-format') || 'number';
        var showDecimal = eval($this.attr('data-decimal')) || false;
        var roundUp = $this.attr('data-round') || true;

        $({ countNum: 0 }).animate(
            { countNum: countTo },
            {
                duration: 2000,
                easing: 'swing',
                step: function () {
                    $this.text(formatNumberCount(Math.floor(this.countNum), countFormat, roundUp, showDecimal));
                },
                complete: function () {
                    $this.text(formatNumberCount(countTo, countFormat, roundUp, showDecimal));
                }
            }
        );
    });

    // carousel-container slick (deferred via IntersectionObserver — below fold)
    const initCarouselSlick = () => {
        const $c = $('.carousel-container');
        if (!$c.length || $c.hasClass('slick-initialized')) return;
        $c.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 300,
        dots: true,
        // arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        dotsClass: 'slick-dots-custom',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
        }).on('setPosition', function() {
            setEqualHeight(this);
        });
    };
    const $carouselEl = document.querySelector('.carousel-container');
    if ($carouselEl) {
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs) => {
                entries.forEach(e => {
                    if (e.isIntersecting) {
                        initCarouselSlick();
                        obs.disconnect();
                    }
                });
            }, { rootMargin: '200px' });
            io.observe($carouselEl);
        } else {
            initCarouselSlick();
        }
    }

    // hero slick slider (deferred to avoid blocking LCP)
    const initHeroSlick = () => {
        const $hero = $('.carousel-lg-container');
        if (!$hero.length || $hero.hasClass('slick-initialized')) return;
        $hero.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dotsClass: 'slick-dots-custom',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }).on('setPosition', function() {
            setEqualHeight(this);
        });
    };
    if ('requestIdleCallback' in window) {
        requestIdleCallback(initHeroSlick, { timeout: 2000 });
    } else {
        setTimeout(initHeroSlick, 200);
    }

    $('.min-number').each(function() {
        let val = parseFloat($(this).text().trim());
        if (!isNaN(val)) {
            $(this).text(formatNumber(val));
        }else{
            $(this).text('n.a.');
        }
    });


    $('.previewFileRaw').each(function(){
        let link = $(this).data('link');
        let linkEncoded = $(this).data('link-encoded');
        let ext = $(this).data('ext') ?? link.split('.')[link.split('.').length-1];

        if (iFrameExt.indexOf(ext) === -1 && imagesExt.indexOf(ext) === -1 && moviesExt.indexOf(ext) === -1 && officeExt.indexOf(ext) === -1)
            $(this).addClass('d-none');
        else
            $(this).attr('data-ext', ext);

        let content = '';

        if (iFrameExt.indexOf(ext) !== -1)
            content = '<embed src="'+link+'" style="width:100%; height:700px;">';
        else if (imagesExt.indexOf(ext) !== -1)
            content = '<img  style="max-width:100%;" src="'+link+'">';
        else if (officeExt.indexOf(ext) !== -1)
            content = '<iframe src="https://view.officeapps.live.com/op/embed.aspx?src='+linkEncoded+'" width="100%" height="700px" ></iframe>';
        else if (moviesExt.indexOf(ext) !== -1)
            content = '<video controls style="max-width: 100%"><source src="'+link+'" type="audio/'+ext+'">Your browser does not support the video tag.</video>';
        $(this).html(content);
    });

    $('body').find('.previewFile').each(function(){
        let link = $(this).data('link');
        let ext = link.split('.')[link.split('.').length-1];

        if (iFrameExt.indexOf(ext) === -1 && imagesExt.indexOf(ext) === -1 && moviesExt.indexOf(ext) === -1 && officeExt.indexOf(ext) === -1)
            $(this).addClass('d-none');
        else
            $(this).attr('data-ext', ext);
    });
    $('body').on('click', '.previewFile', function (e){
        e.preventDefault();
        let title = $(this).attr('data-title');
        let link = $(this).attr('data-link');
        let linkEncoded = $(this).attr('data-link-encoded');
        let ext = $(this).attr('data-ext') ?? link.split('.')[link.split('.').length-1];
        let content = '';

        if (iFrameExt.indexOf(ext) !== -1)
            content = '<embed src="'+link+'" style="width:100%;height:100%;">';
        else if (imagesExt.indexOf(ext) !== -1)
            content = '<img  style="width:100%;max-height:100%;" src="'+link+'">';
        else if (officeExt.indexOf(ext) !== -1)
            content = '<iframe src="https://view.officeapps.live.com/op/embed.aspx?src='+linkEncoded+'" width="100%" height="100%" ></iframe>';
        else if (moviesExt.indexOf(ext) !== -1)
            content = '<video controls style="width:100%;max-height:100%;"><source src="'+link+'" type="audio/'+ext+'">Your browser does not support the video tag.</video>';
        else if (moviesExt.indexOf(ext) !== -1)
            content = 'can\'t preview the file';

        $('#modalPreviewTitle').html(title);
        $('#modalPreviewBody').html(content).height('80vh');
        $('#modalPreview').modal('show');
    });
    $('#modalPreview').on('hidden.bs.modal', function (){
        $('#modalPreviewBody').html('');
    });
});
